import React from "react";
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes,useLocation } from "react-router-dom";
import {useEffect} from "react";
//import Dashboardheader from "./Dashboardheader";
const DoctorDashboard= () => {
  useEffect(() => {
    const scriptUrls = [
      'assets/js/jquery.min.js',
      'assets/js/bootstrap.bundle.min.js',
      'assets/js/moment.min.js',
      'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
      'assets/vendor/overlay-scroll/custom-scrollbar.js',
      'assets/vendor/daterange/daterange.js',
      'assets/vendor/daterange/custom-daterange.js',
      'assets/vendor/apex/apexcharts.min.js',
      "assets/vendor/apex/custom/doc-dashboard/patients.js",
      "assets/vendor/apex/custom/doc-dashboard/appointments.js",
      "assets/vendor/apex/custom/doc-dashboard/gender.js",
      "assets/vendor/apex/custom/doc-dashboard/surgeries.js",
      "assets/vendor/apex/custom/doc-dashboard/income.js",
      "assets/vendor/rating/raty.js",
      "assets/vendor/rating/raty-custom.js",
      "assets/vendor/datatables/dataTables.min.js",
      "assets/vendor/datatables/dataTables.bootstrap.min.js",
      "assets/vendor/datatables/custom/custom-datatables.js",
      "assets/js/custom.js"
    ];

    let isCancelled = false;

    // Load scripts sequentially
    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
      // Optionally remove scripts if needed
    };
  }, []);
  return(
    <div>
    {/* App hero header starts */}
    <div className="app-hero-header d-flex align-items-center">
      {/* Breadcrumb starts */}
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <a href="index-2.html">
            <i className="ri-home-3-line" />
          </a>
        </li>
        <li className="breadcrumb-item text-primary" aria-current="page">
          Doctors Dashboard
        </li>
      </ol>
      {/* Breadcrumb ends */}
      {/* Sales stats starts */}
      <div className="ms-auto d-lg-flex d-none flex-row">
        <div className="input-group">
          <span className="input-group-text bg-primary-lighten">
            <i className="ri-calendar-2-line text-primary" />
          </span>
          <input type="text" id="abc" className="form-control custom-daterange" />
        </div>
      </div>
      {/* Sales stats ends */}
    </div>
    {/* App Hero header ends */}
    {/* App body starts */}
    <div className="app-body">
      {/* Row starts */}
      <div className="row gx-4">
        <div className="col-sm-12">
          <div className="card mb-4 border">
            <div className="card-body">
              {/* Row starts */}
              <div className="row gx-4">
                <div className="col-xl-6 col-sm-6">
                  <div className="d-flex align-items-start gap-3 flex-wrap">
                    <img src="assets/images/doctors/1.jpg" className="mw-240 rounded-2 border border-primary border-2" alt="Dentist Dashboard" />
                    <div className>
                      <span className="badge bg-primary-subtle text-primary"><i className="ri-circle-fill me-1" />Available</span>
                      <h6 className="fw-normal mt-2">Good Morning,</h6>
                      <h5 className="fw-normal">Dr. Yolanda Skinner</h5>
                      <h6 className="fw-normal">BDS, MDS - General &amp; Gynecologist</h6>
                      <h6 className="fw-normal">Speaks : English, and French</h6>
                      <div className="d-flex mt-3">
                        <div className="rating-stars">
                          <div className="readonly5" />
                        </div>
                        <span className="fw-bold">3860</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-sm-6">
                  {/* Row starts */}
                  <div className="row g-4">
                    <div className="col-sm-4">
                      <div className="card border rounded-5">
                        <div className="card-body">
                          {/* Card details start */}
                          <div className="text-center">
                            <div className="icon-box md border border-primary rounded-5 mb-2 m-auto">
                              <i className="ri-empathize-line fs-5 text-primary" />
                            </div>
                            <h3 className="text-primary">680</h3>
                            <h6>Total Patients</h6>
                            <small className="text-primary">20% Higher than last week.</small>
                          </div>
                          {/* Card details end */}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="card border rounded-5">
                        <div className="card-body">
                          {/* Card details start */}
                          <div className="text-center">
                            <div className="icon-box md border border-primary rounded-5 mb-2 m-auto">
                              <i className="ri-stethoscope-line fs-5 text-primary" />
                            </div>
                            <h3 className="text-primary">30</h3>
                            <h6>Surgeries</h6>
                            <small className="text-primary">30% Higher than last week.</small>
                          </div>
                          {/* Card details end */}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="card border rounded-5">
                        <div className="card-body">
                          {/* Card details start */}
                          <div className="text-center">
                            <div className="icon-box md border border-primary rounded-5 mb-2 m-auto">
                              <i className="ri-money-dollar-circle-line fs-5 text-primary" />
                            </div>
                            <h3 className="text-primary">$980</h3>
                            <h6>Earnings</h6>
                            <small className="text-primary">60% Higher than last week.</small>
                          </div>
                          {/* Card details end */}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Row ends */}
                </div>
              </div>
              {/* Row ends */}
            </div>
          </div>
        </div>
      </div>
      {/* Row ends */}
      {/* Row starts */}
      <div className="row gx-4">
        <div className="col-sm-12">
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title">Appointments</h5>
            </div>
            <div className="card-body">
              <div className="card-info bg-primary-subtle rounded-1 small lh-1">
                21% higher than last year.
              </div>
              <div className="overflow-hidden">
                <div id="appointments" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Row ends */}
      {/* Row starts */}
      <div className="row gx-4">
        <div className="col-sm-12">
          <div className="card mb-4">
            <div className="card-body">
              <h5 className="card-title">Appointments</h5>
              {/* Table starts */}
              <div className="table-responsive">
                <table id="hideSearchExample" className="table m-0 align-middle">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Patient Name</th>
                      <th>Age</th>
                      <th>Time</th>
                      <th>Diagnosis</th>
                      <th>Type</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>001</td>
                      <td>
                        <img src="assets/images/patient.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                        Willian Mathews
                      </td>
                      <td>21</td>
                      <td>
                        10:30AM
                      </td>
                      <td>Heart Attack</td>
                      <td>
                        <span className="badge bg-warning-subtle text-warning fs-6">General</span>
                      </td>
                      <td>
                        <div className="d-inline-flex gap-1">
                          <button type="button" className="btn btn-hover btn-sm rounded-5" data-bs-toggle="modal" data-bs-target="#delRow">
                            <span data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                              <i className="ri-close-fill" />
                            </span>
                          </button>
                          <button type="button" className="btn btn-hover btn-sm rounded-5" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Approve">
                            <i className="ri-check-fill" />
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>002</td>
                      <td>
                        <img src="assets/images/patient1.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                        Adam Bradley
                      </td>
                      <td>36</td>
                      <td>
                        10:45AM
                      </td>
                      <td>Diabetes</td>
                      <td>
                        <span className="badge bg-primary-subtle text-primary fs-6">Consulting</span>
                      </td>
                      <td>
                        <div className="d-inline-flex gap-1">
                          <button type="button" className="btn btn-hover btn-sm rounded-5" data-bs-toggle="modal" data-bs-target="#delRow">
                            <span data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                              <i className="ri-close-fill" />
                            </span>
                          </button>
                          <button type="button" className="btn btn-hover btn-sm rounded-5" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Approve">
                            <i className="ri-check-fill" />
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>003</td>
                      <td>
                        <img src="assets/images/patient2.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                        Mayra Hatfield
                      </td>
                      <td>82</td>
                      <td>
                        11:00AM
                      </td>
                      <td>Chancroid</td>
                      <td>
                        <span className="badge bg-warning-subtle text-warning fs-6">General</span>
                      </td>
                      <td>
                        <div className="d-inline-flex gap-1">
                          <button type="button" className="btn btn-hover btn-sm rounded-5" data-bs-toggle="modal" data-bs-target="#delRow">
                            <span data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                              <i className="ri-close-fill" />
                            </span>
                          </button>
                          <button type="button" className="btn btn-hover btn-sm rounded-5" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Approve">
                            <i className="ri-check-fill" />
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>004</td>
                      <td>
                        <img src="assets/images/patient3.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                        Nicole Sellers
                      </td>
                      <td>29</td>
                      <td>
                        11:15AM
                      </td>
                      <td>Pediatric</td>
                      <td>
                        <span className="badge bg-primary-subtle text-primary fs-6">Consulting</span>
                      </td>
                      <td>
                        <div className="d-inline-flex gap-1">
                          <button type="button" className="btn btn-hover btn-sm rounded-5" data-bs-toggle="modal" data-bs-target="#delRow">
                            <span data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                              <i className="ri-close-fill" />
                            </span>
                          </button>
                          <button type="button" className="btn btn-hover btn-sm rounded-5" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Approve">
                            <i className="ri-check-fill" />
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>005</td>
                      <td>
                        <img src="assets/images/patient4.png" className="img-2x rounded-5 me-1" alt="Doctors Admin Template" />
                        Roseann Kane
                      </td>
                      <td>58</td>
                      <td>
                        11:45AM
                      </td>
                      <td>Alphaviruses</td>
                      <td>
                        <span className="badge bg-warning-subtle text-warning fs-6">General</span>
                      </td>
                      <td>
                        <div className="d-inline-flex gap-1">
                          <button type="button" className="btn btn-hover btn-sm rounded-5" data-bs-toggle="modal" data-bs-target="#delRow">
                            <span data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                              <i className="ri-close-fill" />
                            </span>
                          </button>
                          <button type="button" className="btn btn-hover btn-sm rounded-5" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Approve">
                            <i className="ri-check-fill" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* Table ends */}
              {/* Modal Delete Row */}
              <div className="modal fade" id="delRow" tabIndex={-1} aria-labelledby="delRowLabel" aria-hidden="true">
                <div className="modal-dialog modal-sm">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="delRowLabel">
                        Confirm
                      </h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div className="modal-body">
                      Are you sure you want to reject the Appointment?
                    </div>
                    <div className="modal-footer">
                      <div className="d-flex justify-content-end gap-2">
                        <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>
                        <button type="button" className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close">Yes</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Row ends */}
      {/* Row starts */}
      <div className="row gx-4">
        <div className="col-sm-12">
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title">Patients</h5>
            </div>
            <div className="card-body">
              <div className="card-info bg-primary-subtle rounded-1 small">
                20% higher than last year.
              </div>
              <div className="overflow-hidden">
                <div id="patients" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Row ends */}
      {/* Row starts */}
      <div className="row gx-4">
        <div className="col-xxl-6 col-sm-12">
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title">Patient Reviews</h5>
            </div>
            <div className="card-body">
              {/* Reviews starts */}
              <div className="scroll300">
                <div className="d-grid gap-4">
                  <div className="d-flex">
                    <img src="assets/images/patient1.png" className="img-4x rounded-2" alt="Medical Admin Template" />
                    <div className="ms-3">
                      <h6>Wendi Combs</h6>
                      <p className="mb-2">I had a very good experience here. I got a best psychiatrist and a
                        therapist. They analysed my case very deeply and there medicines helped me a lot.</p>
                      <div className="rating-stars">
                        <div className="readonly5" />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex">
                    <img src="assets/images/patient2.png" className="img-4x rounded-2" alt="Medical Admin Template" />
                    <div className="ms-3">
                      <h6>Nick Morrow</h6>
                      <p className="mb-2">Dr.Rachell listens to you very patiently &amp; gives you sufficient time
                        to say your problems. She diagnosed in no time &amp; i was able to recover quickly, not
                        just
                        diagnosing correctly, she helped me in changing my lifestyle habits.</p>
                      <div className="rating-stars">
                        <div className="readonly5" />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex">
                    <img src="assets/images/patient3.png" className="img-4x rounded-2" alt="Medical Admin Template" />
                    <div className="ms-3">
                      <h6>Carole Dodson</h6>
                      <p className="mb-2">She is very supportive and suggest well. Good surgeon known from past 10
                        years. My mother was a renal transplant patient but in most risky condition she
                        treated
                        her in day care procedure and avoided hospital admission.
                      </p>
                      <div className="rating-stars">
                        <div className="readonly4" />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex">
                    <img src="assets/images/patient4.png" className="img-4x rounded-2" alt="Medical Admin Template" />
                    <div className="ms-3">
                      <h6>Ashley Clay</h6>
                      <p className="mb-2">Rachell is a very good Doctor because I had good experience with hee,
                        she
                        treated my father who is a diabetic patient.
                      </p>
                      <div className="rating-stars">
                        <div className="readonly5" />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex">
                    <img src="assets/images/patient5.png" className="img-4x rounded-2" alt="Medical Admin Template" />
                    <div className="ms-3">
                      <h6>Tonia Woodard</h6>
                      <p className="mb-2">One of the finest doctor’s I ever met. A very good human being more than
                        a
                        doctor.</p>
                      <div className="rating-stars">
                        <div className="readonly4" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Reviews ends */}
            </div>
          </div>
        </div>
        <div className="col-xxl-6 col-sm-12">
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title">Income</h5>
            </div>
            <div className="card-body">
              <div className="scroll300">
                <div className="overflow-hidden">
                  <div id="income" />
                </div>
                <div className="mt-2 text-center">
                  <span className="badge bg-primary">22%</span> income has increase that last year.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-4 col-sm-4">
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title">Recent Patients</h5>
            </div>
            <div className="card-body">
              <div className="scroll300">
                <div className="d-flex flex-column gap-2">
                  <div className="d-flex flex-column p-3 border rounded-2">
                    <div className="d-flex align-items-center flex-row">
                      <img src="assets/images/patient5.png" className="img-4x rounded-5 me-3" alt="Dentist Dashboard" />
                      <div>
                        <h6 className="mb-1">Tonia Woodard</h6>
                        <p className="mb-1 small">Last Appointment 20 Sept 2024</p>
                        <span className="badge bg-primary-subtle text-primary">Patient ID : P0039</span>
                        <p className="mb-3 mt-1">Need an appointment urgent.</p>
                        <div className="d-flex gap-2">
                          <a href="appointments-list.html" className="btn btn-primary btn-sm">
                            Approve
                          </a>
                          <button type="button" className="btn btn-outline-secondary btn-sm">Decline</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-column p-3 border rounded-2">
                    <div className="d-flex align-items-center flex-row mb-3">
                      <img src="assets/images/patient1.png" className="img-4x rounded-5 me-3" alt="Dentist Dashboard" />
                      <div>
                        <h6 className="mb-1">Roseann Kane</h6>
                        <p className="mb-1 small">Last Appointment 26 Sept 2024</p>
                        <span className="badge bg-primary-subtle text-primary">Patient ID : P0063</span>
                        <p className="mb-3 mt-1">Need an appointment urgent.</p>
                        <div className="d-flex gap-2">
                          <a href="appointments-list.html" className="btn btn-primary btn-sm">
                            Approve
                          </a>
                          <button type="button" className="btn btn-outline-secondary btn-sm">Decline</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-column p-3 border rounded-2">
                    <div className="d-flex align-items-center flex-row mb-3">
                      <img src="assets/images/patient2.png" className="img-4x rounded-5 me-3" alt="Dentist Dashboard" />
                      <div>
                        <h6 className="mb-1">Mayra Hatfield</h6>
                        <p className="mb-1 small">Last Appointment 15 Mar 2024</p>
                        <span className="badge bg-primary-subtle text-primary">Patient ID : P0086</span>
                        <p className="mb-3 mt-1">Need an appointment urgent.</p>
                        <div className="d-flex gap-2">
                          <a href="appointments-list.html" className="btn btn-primary btn-sm">
                            Approve
                          </a>
                          <button type="button" className="btn btn-outline-secondary btn-sm">Decline</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-4 col-sm-4">
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title">Patient Age</h5>
            </div>
            <div className="card-body">
              <div className="scroll300 auto-align-graph">
                <div className="overflow-hidden">
                  <div id="gender" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-4 col-sm-4">
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title">Surgeries</h5>
            </div>
            <div className="card-body">
              <div className="scroll300 auto-align-graph">
                <div className="overflow-hidden">
                  <div id="surgeries" />
                </div>
                <div className="mt-2 text-center">
                  <span className="badge bg-primary">22%</span> male patients decreased than last month.
                  <span className="badge bg-danger">38%</span> female patients increase than last month.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Row ends */}
    </div>
    {/* App body ends */}
  </div>
  );
}

export default DoctorDashboard;














